import { trackEvent } from '@intercom/messenger-js-sdk'

export const IntercomEvent = {
  // Teacher Pro events
  AUTOGRADING_CARD_CREATED: 'autograding-card-created',
  AUTOGRADING_USED: 'autograding-used',
  RUBRIC_CREATED: 'rubric-created',
  RUBRIC_USED: 'rubric-used',

  // Org Plan event
  STUDENT_REPORT_VIEWED: 'student-report-viewed',
}

export const trackAutogradingCardCreated = (data = {}) => {
  trackEvent(IntercomEvent.AUTOGRADING_CARD_CREATED, data)
}

export const trackAutogradingUsed = (data = {}) => {
  trackEvent(IntercomEvent.AUTOGRADING_USED, data)
}

export const trackRubricCreated = (data = {}) => {
  trackEvent(IntercomEvent.RUBRIC_CREATED, data)
}

export const trackRubricUsed = (data = {}) => {
  trackEvent(IntercomEvent.RUBRIC_USED, data)
}

export const trackStudentReportViewed = (data = {}) => {
  trackEvent(IntercomEvent.STUDENT_REPORT_VIEWED, data)
}
